import { Outlet } from "react-router-dom";
import { useState } from "react";
import styles from "./Dashboard.module.scss";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import ArrowIcon from "../../assets/icons/ArrowIcon";
import UserPanel from "../../components/UserPanel/UserPanel";
import { useTheme } from "../../contexts/ThemeContext";

export default function DashboardLayout() {
  const [userPanelActive, setUserPanelActive] = useState(true);
  const { theme, toggletheme } = useTheme();

  return (
    <div className={styles.dashboard}>
      <Sidebar />
      <div className={styles.dashboardOutlet}>
        <Header />
        <main className={styles.dashboardOutletMain}>
          <Outlet />
        </main>
        <button
          onClick={() => setUserPanelActive(!userPanelActive)}
          className={`${styles.userPanelButton} ${
            userPanelActive ? "" : styles.rotated
          }`}
        >
          <ArrowIcon theme={theme} />
        </button>
      </div>
      <div
        className={
          userPanelActive ? styles.userPanel : styles.userPanelInactive
        }
      >
        <UserPanel />
      </div>
    </div>
  );
}
